import { useLingui } from '@lingui/react/macro';
import { useEffect } from 'react';
import { BaseDialog, useDialogStore } from 'ui-kit';
import { useAccount } from 'wagmi';
import { AccountPanel } from '../../features/account/components/account_panel.tsx';

export const AccountDialog = () => {
  const { t } = useLingui();
  const { isConnected } = useAccount();
  const { closeDialog, isDialogOpen } = useDialogStore();
  const isOpen = isDialogOpen('accountDialog');

  useEffect(() => {
    if (!isConnected && isOpen) {
      closeDialog('accountDialog');
    }
  }, [isConnected, isOpen, closeDialog]);

  const handleDisconnect = () => {
    closeDialog('accountDialog');
  };

  return (
    <BaseDialog dialogKey="accountDialog" title={t`Account`} maxWidth="xs">
      <AccountPanel onDisconnect={handleDisconnect} />
    </BaseDialog>
  );
};
